const TabManager = (function () {
  let tabHeadings;
  let tabContents;
  let scrollToElements;

  // Initialize the module
  function init() {
    tabHeadings = document.querySelectorAll("[data-tab-heading]");
    tabContents = document.querySelectorAll("[data-tab-content]");
    scrollToElements = document.querySelectorAll(".scroll--to");

    addTabListeners();
    addScrollListeners();
  }

  // Add click listeners to tab headings
  function addTabListeners() {
    tabHeadings.forEach((heading) => {
      heading.addEventListener("click", () => switchTab(heading));
    });
  }

  // Add click listeners to scroll-to elements
  function addScrollListeners() {
    scrollToElements.forEach((element) => {
      element.addEventListener("click", (e) => {
        e.preventDefault();
        const targetId = element.getAttribute("data-scroll-to");
        scrollToElement(targetId);
        activateTabFromScroll(targetId);
      });
    });
  }

  // Switch active tab
  function switchTab(clickedHeading) {
    const tabId = clickedHeading.getAttribute("data-tab-heading");

    tabHeadings.forEach((h) => h.classList.remove("active-tab"));
    clickedHeading.classList.add("active-tab");

    tabContents.forEach((content) =>
      content.classList.remove("active-content")
    );

    const activeContent = document.querySelector(
      `[data-tab-content="${tabId}"]`
    );
    if (activeContent) {
      activeContent.classList.add("active-content");
    }
  }

  // Smooth scroll to element
  function scrollToElement(targetId) {
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }

  // Activate tab based on scrolled element
  function activateTabFromScroll(targetId) {
    const associatedTab = document.querySelector(
      `[data-tab-heading="${targetId}"]`
    );
    if (associatedTab) {
      switchTab(associatedTab);
    }
  }

  // Public methods
  return {
    initialize: init,
  };
})();

const ExpertChatTrigger = {
  init() {
    this.chatButtons = document.querySelectorAll(".expert_chat_wrap .button");
    this.addEventListeners();
  },

  addEventListeners() {
    if (this.chatButtons.length > 0) {
      this.chatButtons.forEach((button) => {
        button.addEventListener("click", this.handleClick.bind(this));
      });
    } else {
      console.warn("No expert chat buttons found.");
    }
  },

  handleClick(event) {
    event.preventDefault();
    console.log("Trigger chat");
    this.triggerChatWidget();
  },

  triggerChatWidget() {
    const elementWithShadowRoot = document.querySelector(
      '[location-id="cFeT6J2nl4i0chn30Cnh"]'
    );

    if (!elementWithShadowRoot) {
      console.error("Element with shadow root not found.");
      return;
    }

    const shadowRoot = elementWithShadowRoot.shadowRoot;

    if (!shadowRoot) {
      console.error("Shadow root not found.");
      return;
    }

    const elementInsideShadow = shadowRoot.querySelector(
      "#lc_text-widget--btn"
    );

    if (elementInsideShadow) {
      elementInsideShadow.click();
    } else {
      console.error("Chat widget button not found inside shadow DOM.");
    }
  },
};

const ProxyQuoteButton = {
  init() {
    this.proxyButton = document.getElementById("get-quote-proxy-btn");
    this.addEventListeners();
  },

  addEventListeners() {
    if (this.proxyButton) {
      this.proxyButton.addEventListener("click", this.handleClick.bind(this));
    } else {
      console.warn("Proxy button or target button not found.");
    }
  },

  handleClick(event) {
    event.preventDefault();
    this.targetButton = document.querySelector("button.product-form__quote");
    if (this.targetButton) {
      this.targetButton.click();
    } else {
      console.error("Target button not found when trying to click.");
    }
  },
};

const ProductModalManager = {
  init() {
    this.crossButton = document.querySelector(".product-media-modal__toggle");
    this.productModal = document.querySelector("product-modal");
    this.swiperContainer = document.querySelector(".swiper-product-container");

    this.setupCrossButton();
    this.initializeSwiper();
  },

  setupCrossButton() {
    if (this.crossButton && this.productModal) {
      this.crossButton.addEventListener(
        "click",
        this.handleCrossButtonClick.bind(this)
      );
    } else {
      console.warn("Cross button or product modal not found.");
    }
  },

  handleCrossButtonClick(event) {
    event.preventDefault();
    if (typeof this.productModal.hideModal === "function") {
      this.productModal.hideModal();
    } else {
      console.error("hideModal method not found on product-modal element.");
    }
  },

  initializeSwiper() {
    if (!this.swiperContainer) {
      console.warn("Swiper container not found.");
      return;
    }

    if (typeof Swiper === "undefined") {
      console.error("Swiper library not loaded.");
      return;
    }

    this.swiperInstance = new Swiper(this.swiperContainer, {
      slidesPerView: 1,
      navigation: {
        nextEl: ".swiper-button-next-modal",
        prevEl: ".swiper-button-prev-modal",
      },
      pagination: {
        el: ".swiper-pagination-modal",
        clickable: true,
      },
      on: {
        init: () => console.log("Product modal swiper initialized"),
        error: (e) => console.error("Swiper error:", e),
      },
    });
  },

  // Public method to get swiper instance
  getSwiperInstance() {
    return this.swiperInstance;
  },
};


const FinancingDataVisibility = {
  init() {
    this.financingData = document.querySelector('#financing_data');
    this.startTime = Date.now();
    this.checkInterval = 100; // Check every 100ms
    this.maxDuration = 10000; // 10 seconds
    this.checkForCalculator();
  },

  checkForCalculator() {
    const calculator = document.querySelector('.calculator-wrapper');
    
    if (calculator) {
      this.showFinancingData();
    } else if (Date.now() - this.startTime < this.maxDuration) {
      setTimeout(() => this.checkForCalculator(), this.checkInterval);
    } else {
      console.warn('Fitow payment calculator not found within 10 seconds.');
    }
  },

  showFinancingData() {
    if (this.financingData) {
      this.financingData.classList.remove('hidden');
      console.log('Financing data is now visible.');
    } else {
      console.error('Financing data element not found.');
    }
  }
};

// Object to manage cart functionality
const CartManager = {
  addToCartBtn: null,
  submitBtn: null,
  originalButtonText: '',

  // Initialization method
  init() {
    this.addToCartBtn = document.getElementById('add_cart_btn_trailer_inven');
    if (this.addToCartBtn) {
      this.originalButtonText = this.addToCartBtn.textContent;
      this.addToCartBtn.addEventListener('click', this.handleAddToCart.bind(this));
    } else {
      this.handleError('Required elements not found. CartManager initialization failed.');
    }
  },

  

  // Method to handle 'Add to Cart' button click
  handleAddToCart(event) {
    event.preventDefault();
     this.submitBtn = document.querySelector('button[type="submit"][name="add"].product-form__submit');
    if (this.submitBtn) {
      this.showLoading();
      // Simulate network request
      setTimeout(() => {
        try {
          this.submitBtn.click();
          // this.updateUIAfterAdd();
        } catch (error) {
          this.handleError('Error triggering submit button', error);
        } finally {
          this.hideLoading();
        }
      }, 1000); // Simulated delay of 1 second
    } else {
      this.handleError('Submit button not found');
    }
  },

  // Method to update UI after successful add to cart
  updateUIAfterAdd() {
    console.log('Item added to cart successfully');
    // this.showNotification('Item added to cart successfully', 'success');
  },

  // Method to show loading state in button
  showLoading() {
    if (this.addToCartBtn) {
      this.addToCartBtn.disabled = true;
      this.addToCartBtn.innerHTML = '<span class="spinner"></span> Adding...';
    }
  },

  // Method to hide loading state in button
  hideLoading() {
    if (this.addToCartBtn) {
      this.addToCartBtn.disabled = false;
      this.addToCartBtn.textContent = this.originalButtonText;
    }
  },

  // Method to show notification
  showNotification(message, type) {
    const notification = document.createElement('div');
    notification.textContent = message;
    notification.className = `notification ${type}`;
    document.body.appendChild(notification);

    setTimeout(() => {
      notification.remove();
    }, 3000);
  },

  // Error handling method
  handleError(message, error = null) {
    console.error(message, error);
    this.showNotification(message, 'error');
  }
};

class EventBridge {
    constructor(triggerSelector, targetSelector) {
        this.triggerElements = document.querySelectorAll(triggerSelector);
        this.targetSelector = targetSelector;
        this.init();
    }

    init() {
        if (this.triggerElements.length > 0) {
            this.triggerElements.forEach(element => {
                element.addEventListener('click', (e) => this.handleClick(e));
            });
        }
    }

    handleClick(e) {
        e.preventDefault();
        const targetElement = document.querySelector(this.targetSelector);
        if (targetElement) {
            targetElement.click();
        }
    }
}


document.addEventListener("DOMContentLoaded", () => {
  // Initialize ProxyQuoteButton
  ProxyQuoteButton.init();
  // Initialize Expert button click
  ExpertChatTrigger.init();
  // Initialize Product modal images to swiper
  ProductModalManager.init();
  // Initialize TabManager
  TabManager.initialize();
  // Finance data show
  FinancingDataVisibility.init();
  // Initialize the CartManager when the DOM is fully loaded
  CartManager.init()
  // Initialize the class
  new EventBridge('.get-preapproved-button', '.rfq-btn[data-product-id]');
  
  // Old codes - start here

  // pdp video thumbnails
  function extractYouTubeVideoId(url) {
    var regex =
      /(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    var match = url.match(regex);
    return match ? match[1] : null;
  }

  var iframeElement = document.querySelector(
    ".product_description_wrap iframe"
  );
  if (iframeElement) {
    var iframeSrc = iframeElement.src;

    var videoId = extractYouTubeVideoId(iframeSrc);
    document
      .querySelector(".description-contents_wrap")
      .setAttribute("data-id", videoId);

    var containerDiv = document.createElement("div");
    containerDiv.className = "video-container";

    var imageDiv = document.createElement("div");
    imageDiv.className = "video-thumbnail-container";

    var imgElement = document.createElement("img");
    imgElement.src = "https://img.youtube.com/vi/" + videoId + "/0.jpg";

    imageDiv.appendChild(imgElement);

    var iconsDiv = document.createElement("div");
    iconsDiv.className = "additional-icons";
    iconsDiv.innerHTML =
      '<svg width="28" height="32" viewBox="0 0 28 32" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M27.2536 14.3552L3.07724 0.376896C1.64297 -0.316136 0 -0.244196 0 2.24364V29.7685C0 32.0429 1.76261 32.4014 3.07724 31.6353L27.2536 17.6571C28.2488 16.7447 28.2488 15.2674 27.2536 14.3552Z" fill="white"/> </svg>';

    containerDiv.appendChild(imageDiv);
    containerDiv.appendChild(iconsDiv);

    iframeElement.parentNode.replaceChild(containerDiv, iframeElement);
  } else {
    console.log("Iframe not found");
  }

  $(document).on("click", ".additional-icons", function () {
    $(".video-container").html(
      '<iframe width="100%" height="230" src="https://www.youtube.com/embed/' +
        document
          .querySelector(".description-contents_wrap")
          .getAttribute("data-id") +
        '?autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>'
    );

    $(this).closest(".video-container").find("img").hide();
  });
  // end of pdp video thumbnails

  var text = "{ " + $(".product__title h1").text() + ":";
  $(".option-name").each(function () {
    text =
      text +
      " " +
      $(this).attr("data-val") +
      " -> " +
      $(
        '[name="' +
          $(this).parent().parent().find("input").attr("name") +
          '"]:checked'
      ).attr("data-val") +
      ",";
  });
  text = text + "}, ";

  $("#textarea-1705990912496").val($("#textarea-1705990912496").val() + text);
  

// -----------------------------------------------------------
// 6. Initialize Fancybox
// -----------------------------------------------------------
Fancybox.bind("[data-fancybox]", {
  loop: true,
  hash: false,
  autoFocus: false,
  placeFocusBack: false,
});

// Badge click handler
const imageCountBadge = document.querySelector('.product-images-count-badge-container');
if(imageCountBadge){
  imageCountBadge.addEventListener('click', function(e) {
    e.preventDefault();
    const firstGalleryItem = document.querySelector('.mainSliderCutom a[data-fancybox]');
    if (firstGalleryItem) firstGalleryItem.click();
  });
}

});
